import { GetterTree } from 'vuex'
import { OriginatorsState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<OriginatorsState, RootState> = {
    originators:state => state.originators,
    originatorItem:state => state.originatorItem,
};